import { Link } from 'react-router-dom';
import { categories } from '@/mocks/types';

export default function CategoryGrid() {
  const displayCategories = categories.slice(0, 8);

  return (
    <section className="py-12 md:py-16 bg-background-100" aria-labelledby="categories-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 id="categories-heading" className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">涵盖多种类型，总有一款适合你</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 md:p-6 flex flex-col items-center text-center cursor-pointer hover:bg-primary-50 transition-colors duration-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-200 mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            浏览全部分类 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}